import { Navigate, Outlet } from 'react-router-dom'

import './AuthLayout.css'

const AuthLayout = () => {
  return (
    localStorage.getItem('token') ? <Navigate to="/app" /> : <div id="auth-layout">
      <img src="/assets/img/bubble.png" alt="پتروماه" className="bubble" />
      <img id="auth-logo" src="/assets/img/logo.png" alt="پتروماه" />
      <div id="auth-container">
        <Outlet />
      </div>
    </div>
  )
}

export default AuthLayout